// extracted by mini-css-extract-plugin
export default {"Scheme":"styles_Scheme__qth98","active":"styles_active__ER0qB","color":"styles_color__M+g93"};